import { Sprite } from "@pixi/sprite";
import { IDestroyOptions } from "pixi.js";
import { ButtonWithScaleAndPosYAnimation } from "../../../common/components/ButtonWithScaleAndPosYAnimation";
import { GameResourcePackage } from "../../../game/resources/GameResourcePackage";

export class FixBuildingButton extends ButtonWithScaleAndPosYAnimation {
    private readonly gameResources: GameResourcePackage;
    private houseIcon: Sprite;

    public constructor(gameResources: GameResourcePackage) {
        super(gameResources.assets_views_game_ui_building_button_my_building_button_png);
        this.gameResources = gameResources;
        this.build();
        this.onUp.add(this.showUpgradePopup, this);
    }

    private build(): void {
        this.houseIcon = new Sprite(this.gameResources.assets_views_game_ui_building_button_MB_icon_png);
        this.houseIcon.position.set((this.defaultView.width - this.houseIcon.width) * 0.5 + 2, (this.defaultView.height - this.houseIcon.height) * 0.5 - 3);
        this.houseIcon.tint = 0xFC414B;
        this.addChild(this.houseIcon);

        const light = new Sprite(this.gameResources.assets_views_game_ui_building_button_light_red_png);
        light.position.set((this.defaultView.width - light.width) * 0.5, this.defaultView.height - light.height * 0.5 + 16);
        this.addChild(light);

        const hardHat = new Sprite(this.gameResources.assets_views_game_ui_building_button_hard_hat_png);
        hardHat.position.set(60, - 40);
        this.addChild(hardHat);
    }

    private async showUpgradePopup(): Promise<void> {
        this.interactive = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.showUpgradePopup, this);
        super.destroy(options);
    }
}
